export const fragColourMatrix = `
precision mediump float;

uniform sampler2D uSampler;
varying vec2 outTexCoord;

void main ()
{
  // Doesn't work/exist... might be webGL 2 only :?
  // vec4 color = gl_Color;

  vec4 color = texture2D(uSampler, outTexCoord);

  gl_FragColor = color;
}
`;
